import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';
import * as GameEngine from '../../../services/gameEngine';

const TossPhase = ({ onTossComplete }) => {
  const [tossResult, setTossResult] = useState(null);
  const [isFlipping, setIsFlipping] = useState(false);
  const [showChoice, setShowChoice] = useState(false);

  const handleToss = async () => {
    setIsFlipping(true);
    
    // Simulate coin flip animation
    await new Promise(resolve => setTimeout(resolve, 2000));
    
    const winner = GameEngine?.simulateToss();
    setTossResult(winner);
    setIsFlipping(false);
    
    if (winner === 'ai') {
      // AI automatically chooses
      await new Promise(resolve => setTimeout(resolve, 1000));
      const aiChoice = Math.random() > 0.5 ? 'bat' : 'bowl';
      onTossComplete('ai', aiChoice);
    } else {
      setShowChoice(true);
    }
  };

  const handlePlayerChoice = (choice) => {
    onTossComplete('player', choice);
  };

  return (
    <div className="toss-phase-container max-w-2xl mx-auto">
      <div className="bg-card/90 backdrop-blur-sm border-2 border-primary rounded-sm p-6 md:p-8 lg:p-10 text-center space-y-6">
        <div className="space-y-3">
          <div className="w-20 h-20 md:w-24 md:h-24 mx-auto bg-primary/20 rounded-full flex items-center justify-center border-2 border-primary shadow-glow-cyan-lg">
            <Icon 
              name="Coins" 
              size={48} 
              color="var(--color-primary)" 
              className={isFlipping ? 'animate-spin' : ''}
            />
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-primary neon-text-cyan">
            TOSS PHASE
          </h2>
          <p className="text-sm md:text-base font-caption text-muted-foreground">
            {!tossResult && !isFlipping && "Click the button to flip the coin"}
            {isFlipping && "Flipping coin..."}
            {tossResult === 'player' && !showChoice && "You won the toss!"}
            {tossResult === 'ai' && "AI won the toss..."}
          </p>
        </div>

        {!tossResult && !isFlipping && (
          <Button
            variant="default"
            size="xl"
            onClick={handleToss}
            iconName="Coins"
            iconPosition="left"
            className="shadow-glow-cyan-lg hover:shadow-glow-cyan-md"
          >
            FLIP COIN
          </Button>
        )}

        {showChoice && tossResult === 'player' && (
          <div className="space-y-4">
            <p className="text-base md:text-lg font-caption text-primary">
              Choose to BAT or BOWL first:
            </p>
            <div className="grid grid-cols-2 gap-4">
              <Button
                variant="default"
                size="xl"
                onClick={() => handlePlayerChoice('bat')}
                iconName="Target"
                iconPosition="left"
                className="h-20 md:h-24 text-xl shadow-glow-cyan-lg hover:shadow-glow-cyan-md active:scale-95 active:shadow-glow-magenta-md"
              >
                BAT FIRST
              </Button>
              <Button
                variant="secondary"
                size="xl"
                onClick={() => handlePlayerChoice('bowl')}
                iconName="Crosshair"
                iconPosition="left"
                className="h-20 md:h-24 text-xl shadow-glow-magenta-lg hover:shadow-glow-magenta-md active:scale-95 active:shadow-glow-cyan-md"
              >
                BOWL FIRST
              </Button>
            </div>
          </div>
        )}

        {isFlipping && (
          <div className="flex items-center justify-center gap-2">
            <div className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '0ms' }} />
            <div className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '150ms' }} />
            <div className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '300ms' }} />
          </div>
        )}
      </div>

      <div className="mt-6 bg-card/70 backdrop-blur-sm border border-accent/30 rounded-sm p-4 text-center">
        <p className="text-xs md:text-sm font-caption text-muted-foreground">
          <Icon name="Info" size={14} className="inline mr-2" />
          Win the toss to choose whether to bat (score runs) or bowl (get AI out) first
        </p>
      </div>
    </div>
  );
};

export default TossPhase;
